module.exports = __webpack_public_path__ + "static/media/rsz_impuestos.23ad3f3f.jpg";